import React from 'react';
import { useSelector } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    WorksheetPageIndex,
    WorksheetEntitySummaryIndex
} from 'services/worksheet/types';
import { makeSelectOrchard } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
    entitySummaryIndex: WorksheetEntitySummaryIndex;
}

type Props = OwnProps;

export default function OrchardTableCell(props: Props): React.ReactElement {
    const orchard = useSelector((state: AppState) =>
        makeSelectOrchard()(state, props)
    );

    return <TableCell>{orchard}</TableCell>;
}
